export default {"src":"/_next/static/media/check-to-slot-classic-solid.0fbd3978.svg","height":24,"width":24};